<template>
  <div class="lib-wrapper">
    <div class="info-box">
      <h3>Search Macalester Collections and Beyond</h3>
      <div class="icon-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" width="172" height="18" viewBox="0 0 172 18" fill="none">
          <path
            d="M91.741 4.77778C91.5431 4.77778 91.3452 4.73778 91.1869 4.65778C91.0285 4.57778 90.8702 4.49778 90.7514 4.33778C90.6327 4.21778 90.5139 4.05778 90.4348 3.89778C90.3556 3.73778 90.316 3.53778 90.316 3.33778C90.316 3.13778 90.3556 2.97778 90.4348 2.77778C90.5139 2.61778 90.5931 2.45778 90.7514 2.33778C90.8702 2.21778 91.0285 2.09778 91.1869 2.01778C91.3452 1.93778 91.5431 1.89778 91.741 1.89778C91.9389 1.89778 92.1369 1.93778 92.2952 2.01778C92.4535 2.09778 92.6119 2.17778 92.7306 2.33778C92.8494 2.45778 92.9681 2.61778 93.0473 2.77778C93.1264 2.93778 93.166 3.13778 93.166 3.33778C93.166 3.53778 93.1264 3.69778 93.0473 3.89778C92.9681 4.05778 92.8889 4.21778 92.7306 4.33778C92.6119 4.45778 92.4535 4.57778 92.2952 4.65778C92.1369 4.73778 91.9389 4.77778 91.741 4.77778ZM91.741 4.65778C91.9389 4.65778 92.0973 4.61778 92.2556 4.53778C92.4139 4.45778 92.5327 4.37778 92.6514 4.25778C92.7702 4.13778 92.8494 4.01778 92.9285 3.85778C93.0077 3.69778 93.0077 3.53778 93.0077 3.33778C93.0077 3.17778 92.9681 2.97778 92.9285 2.85778C92.8494 2.69778 92.7702 2.57778 92.6514 2.45778C92.5327 2.33778 92.4139 2.25778 92.2556 2.17778C92.0973 2.09778 91.9389 2.05778 91.741 2.05778C91.5431 2.05778 91.3848 2.09778 91.2264 2.17778C91.0681 2.25778 90.9494 2.33778 90.8306 2.45778C90.7119 2.57778 90.6327 2.69778 90.5535 2.85778C90.4744 3.01778 90.4744 3.17778 90.4744 3.37778C90.4744 3.53778 90.5139 3.73778 90.5535 3.85778C90.6327 4.01778 90.7119 4.13778 90.8306 4.25778C90.9494 4.37778 91.0681 4.45778 91.2264 4.53778C91.3848 4.61778 91.5827 4.65778 91.741 4.65778ZM91.1869 2.57778H91.8598C92.0577 2.57778 92.216 2.61778 92.2952 2.73778C92.3744 2.81778 92.4139 2.93778 92.4139 3.05778C92.4139 3.17778 92.3744 3.25778 92.3348 3.33778C92.2556 3.41778 92.1764 3.45778 92.0973 3.49778L92.4931 4.05778H92.1369L91.7806 3.53778H91.4639V4.05778H91.1869V2.57778ZM91.8202 3.29778C91.8994 3.29778 91.9785 3.25778 92.0181 3.21778C92.0577 3.17778 92.0973 3.13778 92.0973 3.05778C92.0973 2.97778 92.0577 2.93778 92.0181 2.89778C91.9785 2.85778 91.8994 2.85778 91.8202 2.85778H91.4639V3.33778H91.8202V3.29778Z"
            fill="#1D252D" />
          <path
            d="M19.8181 2.73778H21.1639L24.2514 11.8578L27.2202 2.69778H28.2098L31.1785 11.8578L34.266 2.73778H35.5723L31.6931 13.7778H30.7035L27.7348 4.85778L24.7264 13.7778H23.6973L19.8181 2.73778Z"
            fill="#1D252D" />
          <path
            d="M39.7681 13.8978C39.1744 13.8978 38.6202 13.7778 38.1056 13.5778C37.591 13.3378 37.1556 13.0578 36.7994 12.6578C36.4431 12.2578 36.1264 11.8178 35.9285 11.3378C35.7306 10.8178 35.6119 10.2978 35.6119 9.69778V9.65778C35.6119 9.09778 35.7306 8.53778 35.9285 8.01778C36.1264 7.49778 36.4431 7.05778 36.7994 6.65778C37.1556 6.25778 37.6306 5.97778 38.1056 5.73778C38.6202 5.49778 39.1744 5.41778 39.7681 5.41778C40.3619 5.41778 40.916 5.53778 41.4306 5.73778C41.9452 5.97778 42.3806 6.25778 42.7369 6.65778C43.0931 7.05778 43.4098 7.49778 43.6077 7.97778C43.8056 8.45778 43.9244 9.01778 43.9244 9.61778V9.65778C43.9244 10.2178 43.8056 10.7778 43.6077 11.2978C43.4098 11.8178 43.0931 12.2578 42.7369 12.6578C42.3806 13.0578 41.9056 13.3378 41.4306 13.5778C40.9556 13.8178 40.4014 13.8978 39.7681 13.8978ZM39.8077 12.8178C40.2431 12.8178 40.6389 12.7378 40.9952 12.5778C41.3514 12.4178 41.6681 12.1778 41.9452 11.8978C42.2223 11.6178 42.4202 11.2978 42.5389 10.8978C42.6973 10.5378 42.7369 10.1378 42.7369 9.69778V9.65778C42.7369 9.21778 42.6577 8.81778 42.4994 8.41778C42.341 8.01778 42.1431 7.69778 41.866 7.41778C41.5889 7.13778 41.2723 6.89778 40.916 6.73778C40.5598 6.57778 40.1639 6.49778 39.7285 6.49778C39.2931 6.49778 38.8973 6.57778 38.541 6.73778C38.1848 6.89778 37.8681 7.13778 37.6306 7.41778C37.3931 7.69778 37.1952 8.01778 37.0369 8.41778C36.8785 8.81778 36.8389 9.21778 36.8389 9.61778V9.65778C36.8389 10.0978 36.9181 10.4978 37.0764 10.8978C37.2348 11.2978 37.4327 11.6178 37.7098 11.8978C37.9869 12.1778 38.3035 12.4178 38.6598 12.5778C39.016 12.7378 39.4119 12.8178 39.8077 12.8178Z"
            fill="#1D252D" />
          <path
            d="M45.4681 5.61778H46.6556V7.73778C46.8139 7.41778 46.9723 7.09778 47.2098 6.81778C47.4077 6.53778 47.6848 6.29778 47.9619 6.09778C48.2389 5.89778 48.5556 5.73778 48.8723 5.61778C49.1889 5.49778 49.5452 5.45778 49.941 5.49778V6.81778H49.8619C49.4264 6.81778 49.0306 6.89778 48.6348 7.05778C48.2389 7.21778 47.9223 7.45778 47.6056 7.77778C47.3285 8.09778 47.091 8.45778 46.9327 8.93778C46.7744 9.37778 46.6952 9.93778 46.6952 10.5378V13.7778H45.5077V5.61778H45.4681Z"
            fill="#1D252D" />
          <path d="M51.5639 2.25778H52.7514V13.6978H51.5639V2.25778Z" fill="#1D252D" />
          <path
            d="M58.4514 13.8978C57.9764 13.8978 57.5014 13.8178 57.066 13.6178C56.591 13.4178 56.1952 13.1378 55.8389 12.7778C55.4827 12.4178 55.2056 11.9778 54.9681 11.4578C54.7702 10.9378 54.6514 10.3378 54.6514 9.69778V9.65778C54.6514 9.01778 54.7702 8.41778 54.9681 7.89778C55.166 7.37778 55.4827 6.93778 55.8389 6.57778C56.1952 6.21778 56.6306 5.93778 57.066 5.73778C57.541 5.53778 57.9764 5.45778 58.4514 5.45778C58.8077 5.45778 59.1639 5.49778 59.4806 5.61778C59.7973 5.73778 60.0744 5.81778 60.3119 5.97778C60.5494 6.13778 60.7869 6.29778 60.9848 6.53778C61.1827 6.73778 61.3806 6.97778 61.5389 7.17778V2.25778H62.7264V13.6978H61.5389V12.0578C61.3806 12.2978 61.1827 12.5378 60.9848 12.7378C60.7869 12.9378 60.5494 13.1378 60.3119 13.2978C60.0744 13.4578 59.7973 13.5778 59.4806 13.6978C59.1639 13.8178 58.8473 13.8978 58.4514 13.8978ZM58.6889 12.8178C59.0452 12.8178 59.4014 12.7378 59.7577 12.5778C60.1139 12.4178 60.4306 12.2178 60.7077 11.9378C60.9848 11.6578 61.1827 11.3378 61.341 10.9378C61.4994 10.5378 61.5785 10.1378 61.5785 9.65778V9.61778C61.5785 9.13778 61.4994 8.73778 61.341 8.33778C61.1827 7.93778 60.9452 7.61778 60.7077 7.37778C60.4306 7.09778 60.1139 6.89778 59.7577 6.73778C59.4014 6.57778 59.0452 6.49778 58.6889 6.49778C58.2931 6.49778 57.9369 6.57778 57.5806 6.69778C57.2244 6.85778 56.9473 7.05778 56.6702 7.29778C56.4327 7.57778 56.2348 7.89778 56.0764 8.25778C55.9181 8.65778 55.8389 9.09778 55.8389 9.57778V9.65778C55.8389 10.1378 55.9181 10.5778 56.0764 10.9778C56.2348 11.3778 56.4327 11.6978 56.6702 11.9778C56.9473 12.2578 57.2244 12.4578 57.5806 12.6178C57.9369 12.7378 58.2931 12.8178 58.6889 12.8178Z"
            fill="#1D252D" />
          <path
            d="M70.2473 13.8978C69.4556 13.8978 68.7431 13.7378 68.0702 13.4578C67.3973 13.1778 66.8431 12.7778 66.3681 12.2578C65.8931 11.7378 65.4973 11.1378 65.2202 10.4578C64.9431 9.77778 64.8244 9.01778 64.8244 8.25778V8.21778C64.8244 7.45778 64.9431 6.69778 65.2202 6.01778C65.4973 5.33778 65.8931 4.73778 66.3681 4.21778C66.8431 3.69778 67.4369 3.29778 68.1098 2.97778C68.7827 2.65778 69.5348 2.53778 70.3264 2.53778C70.841 2.53778 71.2764 2.57778 71.6723 2.65778C72.0681 2.73778 72.4244 2.85778 72.7806 3.01778C73.1369 3.17778 73.4535 3.33778 73.7306 3.57778C74.0077 3.77778 74.2848 4.01778 74.5619 4.29778L73.7306 5.21778C73.2556 4.77778 72.7806 4.41778 72.2264 4.13778C71.7119 3.85778 71.0389 3.69778 70.3264 3.69778C69.7327 3.69778 69.1785 3.81778 68.6639 4.05778C68.1494 4.29778 67.7139 4.61778 67.3181 5.01778C66.9223 5.41778 66.6452 5.89778 66.4473 6.45778C66.2494 7.01778 66.1306 7.57778 66.1306 8.21778V8.25778C66.1306 8.89778 66.2494 9.49778 66.4473 10.0178C66.6452 10.5778 66.9619 11.0578 67.3181 11.4578C67.7139 11.8578 68.1494 12.1778 68.6639 12.4178C69.1785 12.6578 69.7327 12.7778 70.3264 12.7778C71.0785 12.7778 71.7119 12.6578 72.266 12.3778C72.8202 12.0978 73.3348 11.6978 73.8494 11.2178L74.641 12.0178C74.3639 12.2978 74.0869 12.5778 73.7702 12.8178C73.4535 13.0578 73.1369 13.2578 72.7806 13.4178C72.4244 13.5778 72.0681 13.6978 71.6327 13.8178C71.1973 13.8578 70.7619 13.8978 70.2473 13.8978Z"
            fill="#1D252D" />
          <path
            d="M78.7973 13.8978C78.441 13.8978 78.0452 13.8578 77.6889 13.7378C77.3327 13.6178 77.016 13.4578 76.7389 13.2578C76.4619 13.0578 76.2244 12.7778 76.066 12.4578C75.9077 12.1378 75.8285 11.7778 75.8285 11.3778V11.3378C75.8285 10.8978 75.9077 10.4978 76.066 10.1778C76.2244 9.85778 76.4619 9.57778 76.7785 9.33778C77.0952 9.13778 77.4514 8.93778 77.8473 8.81778C78.2827 8.69778 78.7181 8.65778 79.2327 8.65778C79.7473 8.65778 80.1827 8.69778 80.5785 8.73778C80.9744 8.81778 81.3306 8.89778 81.6869 8.97778V8.73778C81.6869 8.01778 81.4889 7.45778 81.0535 7.09778C80.6577 6.73778 80.0639 6.53778 79.3119 6.53778C78.8369 6.53778 78.4014 6.57778 78.0056 6.69778C77.6098 6.81778 77.2535 6.93778 76.8577 7.13778L76.5014 6.13778C76.9369 5.93778 77.4119 5.77778 77.8473 5.65778C78.2827 5.53778 78.8369 5.45778 79.4306 5.45778C80.5785 5.45778 81.4494 5.73778 82.0035 6.33778C82.5577 6.89778 82.8348 7.69778 82.8348 8.73778V13.6978H81.6473V12.4978C81.5285 12.6578 81.3702 12.8578 81.1723 13.0178C80.9744 13.1778 80.7764 13.3378 80.5389 13.4578C80.3014 13.5778 80.0244 13.6978 79.7473 13.7778C79.4702 13.8578 79.1535 13.8978 78.7973 13.8978ZM79.0348 12.8978C79.391 12.8978 79.7473 12.8578 80.0639 12.7378C80.3806 12.6178 80.6577 12.4978 80.8952 12.2978C81.1327 12.0978 81.3306 11.8578 81.4494 11.6178C81.6077 11.3378 81.6473 11.0578 81.6473 10.7378V9.97778C81.3306 9.89778 81.0139 9.81778 80.6181 9.73778C80.2223 9.65778 79.7869 9.61778 79.3119 9.61778C78.5598 9.61778 78.0056 9.77778 77.5702 10.0578C77.1744 10.3378 76.9764 10.7378 76.9764 11.2578V11.2978C76.9764 11.5378 77.016 11.7778 77.1348 11.9778C77.2535 12.1778 77.3723 12.3378 77.5702 12.4978C77.7681 12.6178 77.966 12.7378 78.2035 12.8178C78.5202 12.8578 78.7577 12.8978 79.0348 12.8978Z"
            fill="#1D252D" />
          <path
            d="M87.7431 13.8578C87.4264 13.8578 87.1098 13.8178 86.8327 13.7378C86.5556 13.6578 86.3181 13.5378 86.1202 13.3378C85.9223 13.1378 85.7639 12.9378 85.6452 12.6178C85.5264 12.3378 85.4869 11.9778 85.4869 11.5778V6.69778H84.3785V5.61778H85.4869V3.17778H86.6744V5.61778H89.2077V6.69778H86.6744V11.4178C86.6744 11.9378 86.7931 12.2578 87.0306 12.4578C87.2681 12.6578 87.5848 12.7378 88.0202 12.7378C88.2181 12.7378 88.416 12.6978 88.6139 12.6578C88.8119 12.6178 88.9702 12.5378 89.2077 12.4178V13.4578C89.0098 13.5778 88.7723 13.6578 88.5348 13.6978C88.2973 13.8178 88.0598 13.8578 87.7431 13.8578Z"
            fill="#1D252D" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.88477 8.85778C6.43894 9.05778 6.67644 9.69778 6.47852 10.2578C6.24102 10.8178 5.64727 11.0578 5.0931 10.8578C5.0931 10.8578 4.30144 10.4978 3.82644 10.1778C0.778521 8.25778 1.13477 5.41778 1.49102 3.73778C1.68894 2.97778 2.20352 1.37778 2.20352 1.37778C2.44102 0.817779 3.03477 0.577779 3.58894 0.777779C4.1431 0.977779 4.3806 1.61778 4.18269 2.17778C4.18269 2.17778 3.62852 3.61778 3.50977 4.29778C3.31185 5.37778 2.91602 7.17778 4.97435 8.41778C5.5681 8.73778 5.88477 8.85778 5.88477 8.85778Z"
            fill="#008CCC" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M6.87436 5.77778C6.83477 6.37778 6.32019 6.77778 5.72644 6.73778C5.13269 6.69778 4.69727 6.17778 4.73686 5.57778C4.73686 5.57778 4.85561 4.69778 5.01394 4.17778C5.92436 0.657778 8.69519 0.177778 10.4369 0.0177778C11.1889 -0.0222222 12.8514 0.0177778 12.8514 0.0177778C13.4452 0.0577778 13.841 0.577778 13.8014 1.17778C13.7619 1.77778 13.2473 2.21778 12.6535 2.17778C12.6535 2.17778 11.1098 2.09778 10.4369 2.17778C9.36811 2.29778 7.54727 2.45778 6.99311 4.81778C6.91394 5.41778 6.87436 5.77778 6.87436 5.77778Z"
            fill="#5F4894" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M10.1202 5.69778C9.52644 5.85778 8.97227 5.49778 8.81394 4.93778C8.6556 4.37778 9.01185 3.77778 9.56602 3.61778C9.56602 3.61778 10.4369 3.45778 10.991 3.41778C14.5931 3.13778 15.9389 5.61778 16.6514 7.21778C16.9285 7.89778 17.4431 9.53778 17.4431 9.53778C17.6014 10.0978 17.2452 10.6978 16.691 10.8578C16.1369 11.0178 15.5431 10.6578 15.3848 10.0978C15.3848 10.0978 14.9889 8.61778 14.6723 7.97778C14.1973 7.01778 13.4848 5.29778 11.0702 5.57778C10.4369 5.57778 10.1202 5.69778 10.1202 5.69778Z"
            fill="#AE2573" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11.1098 8.77778C10.7931 8.29778 10.9514 7.61778 11.4264 7.29778C11.9014 6.97778 12.5744 7.13778 12.891 7.61778C12.891 7.61778 13.3264 8.37778 13.5244 8.89778C14.8702 12.2578 12.9702 14.3378 11.6639 15.4978C11.0702 16.0178 9.72436 16.9778 9.72436 16.9778C9.24936 17.2978 8.57644 17.1378 8.25977 16.6578C7.94311 16.1778 8.10144 15.4978 8.57644 15.1778C8.57644 15.1778 9.84311 14.3378 10.3577 13.8578C11.1494 13.0978 12.5348 11.8578 11.5452 9.65778C11.3077 9.05778 11.1098 8.77778 11.1098 8.77778Z"
            fill="#F57F29" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.49727 10.7378C8.85352 10.2578 9.52644 10.2178 10.0014 10.5778C10.4764 10.9378 10.516 11.6178 10.1598 12.0978C10.1598 12.0978 9.56602 12.7778 9.17019 13.1378C6.43894 15.5378 3.90561 14.3778 2.40144 13.4978C1.72852 13.1378 0.382688 12.1378 0.382688 12.1378C-0.0527283 11.7778 -0.131895 11.0978 0.224355 10.6178C0.580605 10.1778 1.25352 10.0978 1.72852 10.4578C1.72852 10.4578 2.9556 11.4178 3.54936 11.6978C4.49935 12.1778 6.08269 13.1378 7.86394 11.4578C8.25977 11.0178 8.49727 10.7378 8.49727 10.7378Z"
            fill="#4C8C2B" />
          <path
            d="M100.37 2.65778L104.447 2.69778C105.318 2.69778 106.11 2.85778 106.822 3.13778C107.535 3.41778 108.129 3.81778 108.643 4.29778C109.158 4.77778 109.554 5.37778 109.831 6.05778C110.108 6.73778 110.226 7.45778 110.226 8.21778V8.25778C110.226 9.05778 110.068 9.77778 109.791 10.4178C109.514 11.0978 109.118 11.6578 108.564 12.1778C108.049 12.6578 107.416 13.0578 106.704 13.3378C105.991 13.6178 105.199 13.7378 104.329 13.7378L100.251 13.6978L100.37 2.65778ZM104.368 11.9778C104.922 11.9778 105.476 11.8978 105.951 11.6978C106.426 11.4978 106.822 11.2578 107.139 10.9378C107.456 10.6178 107.733 10.2178 107.931 9.77778C108.129 9.33778 108.208 8.81778 108.208 8.29778V8.25778C108.208 7.73778 108.129 7.21778 107.931 6.77778C107.733 6.29778 107.495 5.89778 107.179 5.57778C106.862 5.25778 106.466 4.97778 105.991 4.77778C105.516 4.57778 105.001 4.49778 104.447 4.49778H102.27L102.231 11.9778H104.368Z"
            fill="#008CCC" />
          <path d="M111.849 2.33778H113.868V4.13778H111.849V2.33778ZM111.929 5.41778H113.829V13.7778H111.929V5.41778Z"
            fill="#008CCC" />
          <path
            d="M118.658 13.9378C118.064 13.9378 117.47 13.8178 116.837 13.6178C116.243 13.4178 115.649 13.0978 115.135 12.6978L115.966 11.4178C116.401 11.7378 116.876 12.0178 117.351 12.1778C117.826 12.3378 118.262 12.4578 118.697 12.4578C119.093 12.4578 119.41 12.3778 119.647 12.2178C119.885 12.0578 120.004 11.8178 120.004 11.5778V11.5378C120.004 11.3778 119.964 11.2578 119.845 11.1378C119.726 11.0178 119.608 10.9378 119.449 10.8178C119.291 10.7378 119.093 10.6578 118.856 10.5778C118.618 10.4978 118.381 10.4578 118.143 10.3778C117.826 10.2978 117.549 10.1778 117.233 10.0578C116.916 9.93778 116.639 9.77778 116.401 9.61778C116.164 9.41778 115.966 9.21778 115.808 8.93778C115.649 8.65778 115.57 8.33778 115.57 7.93778V7.89778C115.57 7.49778 115.649 7.13778 115.808 6.81778C115.966 6.49778 116.164 6.25778 116.441 6.01778C116.718 5.77778 117.035 5.61778 117.391 5.49778C117.747 5.37778 118.143 5.33778 118.539 5.33778C119.054 5.33778 119.568 5.41778 120.122 5.57778C120.637 5.73778 121.151 5.97778 121.587 6.25778L120.835 7.61778C120.439 7.37778 120.043 7.17778 119.647 7.05778C119.251 6.89778 118.856 6.85778 118.539 6.85778C118.183 6.85778 117.906 6.93778 117.668 7.09778C117.47 7.25778 117.351 7.45778 117.351 7.69778V7.65778C117.351 7.81778 117.391 7.93778 117.51 8.05778C117.629 8.17778 117.747 8.25778 117.906 8.37778C118.064 8.45778 118.262 8.53778 118.499 8.61778C118.737 8.69778 118.974 8.77778 119.212 8.85778C119.529 8.93778 119.806 9.05778 120.122 9.17778C120.439 9.29778 120.716 9.45778 120.954 9.65778C121.191 9.85778 121.389 10.0578 121.547 10.3378C121.706 10.6178 121.785 10.9378 121.785 11.2978V11.3378C121.785 11.7778 121.706 12.1778 121.547 12.4978C121.389 12.8178 121.191 13.0978 120.914 13.2978C120.637 13.4978 120.32 13.6578 119.924 13.7778C119.489 13.8978 119.054 13.9378 118.658 13.9378Z"
            fill="#008CCC" />
          <path
            d="M126.97 13.9778C126.337 13.9778 125.783 13.8578 125.268 13.6178C124.754 13.3778 124.279 13.0978 123.922 12.6978C123.526 12.2978 123.249 11.8578 123.012 11.3378C122.814 10.8178 122.695 10.2578 122.695 9.65778V9.61778C122.695 9.01778 122.814 8.45778 123.012 7.93778C123.21 7.41778 123.526 6.93778 123.922 6.53778C124.318 6.13778 124.754 5.81778 125.268 5.57778C125.783 5.33778 126.376 5.21778 126.97 5.21778C127.762 5.21778 128.395 5.33778 128.91 5.61778C129.424 5.89778 129.86 6.21778 130.256 6.65778L129.068 7.93778C128.791 7.61778 128.474 7.37778 128.118 7.17778C127.801 6.97778 127.366 6.89778 126.891 6.89778C126.535 6.89778 126.218 6.97778 125.941 7.09778C125.664 7.25778 125.387 7.41778 125.189 7.65778C124.991 7.89778 124.833 8.17778 124.714 8.49778C124.595 8.81778 124.516 9.17778 124.516 9.53778V9.57778C124.516 9.93778 124.595 10.2978 124.714 10.6178C124.833 10.9378 124.991 11.2178 125.229 11.4578C125.466 11.6978 125.704 11.8978 126.02 12.0178C126.337 12.1778 126.654 12.2178 127.01 12.2178C127.445 12.2178 127.841 12.1378 128.197 11.9378C128.554 11.7378 128.87 11.4978 129.147 11.1778L130.295 12.2978C130.097 12.5378 129.899 12.7378 129.662 12.9378C129.424 13.1378 129.187 13.2978 128.91 13.4178C128.633 13.5378 128.356 13.6578 127.999 13.7378C127.722 13.9378 127.366 13.9778 126.97 13.9778Z"
            fill="#008CCC" />
          <path
            d="M135.283 13.9778C134.649 13.9778 134.056 13.8578 133.541 13.6178C132.987 13.3778 132.551 13.0978 132.156 12.6978C131.76 12.2978 131.443 11.8578 131.245 11.3378C131.008 10.8178 130.929 10.2578 130.929 9.65778V9.61778C130.929 9.01778 131.047 8.45778 131.285 7.93778C131.522 7.41778 131.799 6.93778 132.195 6.53778C132.591 6.13778 133.066 5.81778 133.581 5.57778C134.135 5.33778 134.689 5.21778 135.322 5.21778C135.956 5.21778 136.549 5.33778 137.064 5.57778C137.618 5.81778 138.054 6.09778 138.449 6.49778C138.845 6.89778 139.162 7.33778 139.36 7.85778C139.558 8.37778 139.676 8.93778 139.676 9.53778V9.57778C139.676 10.1778 139.558 10.7378 139.32 11.2578C139.083 11.7778 138.806 12.2578 138.41 12.6578C138.014 13.0578 137.539 13.3778 137.024 13.6178C136.51 13.8578 135.916 13.9778 135.283 13.9778ZM135.283 12.2978C135.679 12.2978 136.035 12.2178 136.312 12.0978C136.629 11.9378 136.866 11.7778 137.104 11.5378C137.341 11.2978 137.499 11.0178 137.618 10.6978C137.737 10.3778 137.776 10.0178 137.776 9.65778V9.61778C137.776 9.25778 137.697 8.89778 137.579 8.57778C137.46 8.25778 137.262 7.97778 137.064 7.73778C136.826 7.49778 136.589 7.29778 136.272 7.17778C135.956 7.01778 135.639 6.97778 135.243 6.97778C134.887 6.97778 134.531 7.05778 134.214 7.17778C133.897 7.33778 133.66 7.49778 133.422 7.73778C133.185 7.97778 133.026 8.25778 132.908 8.57778C132.789 8.89778 132.749 9.25778 132.749 9.61778V9.65778C132.749 10.0178 132.829 10.3778 132.947 10.6978C133.066 11.0178 133.264 11.2978 133.462 11.5778C133.699 11.8178 133.937 12.0178 134.254 12.1778C134.61 12.2578 134.926 12.2978 135.283 12.2978Z"
            fill="#008CCC" />
          <path
            d="M139.874 5.41778H141.893L144.11 11.5378L146.366 5.41778H148.345L144.981 13.8178H143.279L139.874 5.41778Z"
            fill="#008CCC" />
          <path
            d="M152.779 13.9778C152.185 13.9778 151.631 13.8578 151.116 13.6578C150.601 13.4578 150.166 13.1378 149.77 12.7778C149.374 12.4178 149.097 11.9378 148.86 11.4178C148.622 10.8978 148.543 10.2978 148.543 9.65777V9.61777C148.543 9.01777 148.662 8.45777 148.86 7.93777C149.058 7.41777 149.335 6.93777 149.691 6.53777C150.047 6.13777 150.483 5.81777 150.958 5.61777C151.433 5.37777 151.987 5.25777 152.581 5.25777C153.254 5.25777 153.808 5.37777 154.322 5.61777C154.837 5.85777 155.233 6.17777 155.549 6.61777C155.866 7.01777 156.143 7.49777 156.301 8.05777C156.46 8.61777 156.539 9.17777 156.539 9.77777C156.539 9.85777 156.539 9.93777 156.539 10.0578C156.539 10.1378 156.539 10.2578 156.499 10.3378H150.443C150.562 11.0178 150.799 11.5378 151.235 11.8978C151.67 12.2578 152.185 12.4578 152.818 12.4578C153.293 12.4578 153.689 12.3778 154.045 12.2178C154.401 12.0578 154.718 11.8178 155.074 11.4578L156.183 12.4578C155.787 12.9378 155.312 13.2978 154.758 13.5778C154.204 13.8178 153.531 13.9778 152.779 13.9778ZM154.679 9.01777C154.639 8.69777 154.56 8.41777 154.481 8.13777C154.362 7.85777 154.243 7.61777 154.045 7.41777C153.887 7.21777 153.649 7.05777 153.412 6.93777C153.174 6.81777 152.897 6.77777 152.581 6.77777C151.987 6.77777 151.512 6.97777 151.116 7.37777C150.72 7.77777 150.522 8.29777 150.404 8.97777H154.679V9.01777Z"
            fill="#008CCC" />
          <path
            d="M157.964 5.41777H159.864V7.29778C160.141 6.65777 160.497 6.17777 160.972 5.77777C161.447 5.41777 162.041 5.21777 162.793 5.25777V7.29778H162.674C162.239 7.29778 161.883 7.37777 161.526 7.49777C161.17 7.61777 160.893 7.85777 160.616 8.09777C160.379 8.37777 160.181 8.69778 160.022 9.13778C159.904 9.53778 159.824 10.0178 159.824 10.5778V13.7378H157.924V5.41777H157.964Z"
            fill="#008CCC" />
          <path
            d="M165.604 16.3778C165.208 16.3778 164.851 16.3378 164.535 16.2578C164.218 16.1778 163.941 16.0578 163.624 15.8978L164.258 14.4578C164.416 14.5378 164.614 14.6178 164.812 14.6978C165.01 14.7378 165.168 14.7778 165.366 14.7778C165.643 14.7778 165.881 14.6978 166.039 14.5778C166.197 14.4578 166.395 14.1778 166.554 13.8178L163.11 5.45778H165.129L167.464 11.6578L169.601 5.45778H171.581L168.295 14.0578C168.137 14.4978 167.939 14.8578 167.781 15.1378C167.622 15.4178 167.424 15.6578 167.187 15.8578C166.949 16.0578 166.712 16.1778 166.474 16.2578C166.237 16.2978 165.96 16.3778 165.604 16.3778Z"
            fill="#008CCC" />
        </svg>
        <div class="tooltip-container">

          <svg xmlns="http://www.w3.org/2000/svg" class="info-icon" @mouseenter="showTooltip = true"
            @mouseleave="showTooltip = false" width="15" height="15" viewBox="0 0 12 12" fill="none">
            <path
              d="M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM5.0625 7.875H5.625V6.375H5.0625C4.75078 6.375 4.5 6.12422 4.5 5.8125C4.5 5.50078 4.75078 5.25 5.0625 5.25H6.1875C6.49922 5.25 6.75 5.50078 6.75 5.8125V7.875H6.9375C7.24922 7.875 7.5 8.12578 7.5 8.4375C7.5 8.74922 7.24922 9 6.9375 9H5.0625C4.75078 9 4.5 8.74922 4.5 8.4375C4.5 8.12578 4.75078 7.875 5.0625 7.875ZM6 3C6.19891 3 6.38968 3.07902 6.53033 3.21967C6.67098 3.36032 6.75 3.55109 6.75 3.75C6.75 3.94891 6.67098 4.13968 6.53033 4.28033C6.38968 4.42098 6.19891 4.5 6 4.5C5.80109 4.5 5.61032 4.42098 5.46967 4.28033C5.32902 4.13968 5.25 3.94891 5.25 3.75C5.25 3.55109 5.32902 3.36032 5.46967 3.21967C5.61032 3.07902 5.80109 3 6 3Z"
              fill="#01426A" />
          </svg>

          <transition name="fade">
            <div v-if="showTooltip" class="tooltip">
              <p>Use WorldCat Discovery to search for materials both within the Macalester library and at other
                libraries worldwide. This searches a variety of databases to find books, articles, videos, and more,
                and
                you can choose to refine the databases and search parameters to better fit your needs.</p>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="library-search-bar">
      <div class="search-box">
        <form ref="WorldCatSearch" role="form" id="search-form" name="search-form-world-cat"
          class="library-search-form world-cat" action="https://macalester.on.worldcat.org/search" method="get"
          data-stat-page-section="Header" data-stat-link-type="CUSTOM" data-stat-name="Search Button">

          <!-- Search row with input and button -->
          <div class="search-row">
            <input placeholder="Enter title, keyword, author, etc" id="WorldCatSearch" name="queryString" type="text"
              ref="searchQuery" autofocus="" class="the-header-search__input">

            <button class="the-header-search__input-button" type="submit" id="worldCatSubmit"
              @click="formSubmit('WorldCat')" aria-label="Submit Search">

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19.5 9.75C19.5 11.9016 18.8016 13.8891 17.625 15.5016L23.5594 21.4406C24.1453 22.0266 24.1453 22.9781 23.5594 23.5641C22.9734 24.15 22.0219 24.15 21.4359 23.5641L15.5016 17.625C13.8891 18.8016 11.9016 19.5 9.75 19.5C4.36406 19.5 0 15.1359 0 9.75C0 4.36406 4.36406 0 9.75 0C15.1359 0 19.5 4.36406 19.5 9.75ZM9.75 16.5C13.4766 16.5 16.5 13.4766 16.5 9.75C16.5 6.02344 13.4766 3 9.75 3C6.02344 3 3 6.02344 3 9.75C3 13.4766 6.02344 16.5 9.75 16.5Z"
                  fill="white" />
              </svg>
            </button>
          </div>

          <div id="checkboxDiv">
            <label id="checkBox">
              <!-- Add back the actual checkbox input -->
              <input type="checkbox" v-model="includeSpecialCollection" @change="handleCheckboxChange"
                class="hidden-checkbox" />
              <!-- Hidden input for form submission -->
              <input type="hidden" name="scope" v-if="includeSpecialCollection" value="wz:1703" />

              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"
                class="custom-checkbox">
                <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#01426A"
                  :fill="includeSpecialCollection ? '#01426A' : 'none'" />
                <g v-if="includeSpecialCollection" transform="translate(3, 2)">
                  <g clip-path="url(#clip0_2003_17)">
                    <path
                      d="M7.83196 2.05859C8.05517 2.30273 8.05517 2.69922 7.83196 2.94336L3.26053 7.94336C3.03731 8.1875 2.67481 8.1875 2.4516 7.94336L0.165885 5.44336C-0.0573295 5.19922 -0.0573295 4.80273 0.165885 4.55859C0.389099 4.31445 0.751599 4.31445 0.974813 4.55859L2.85696 6.61523L7.02481 2.05859C7.24803 1.81445 7.61053 1.81445 7.83374 2.05859H7.83196Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2003_17">
                      <rect width="8" height="10" fill="white" />
                    </clipPath>
                  </defs>
                </g>
              </svg>
              Limit to Macalester Library Collections
            </label>
            <span class="advSearch">
              <a href="https://macalester.on.worldcat.org/advancedsearch?_gl=1*1kqyy4j*_ga*MzYwNjk3NDIyLjE2ODgwMTQwMjM.*_ga_TCD2B94FV6*MTY5MTYxMDk1NS42Ny4xLjE2OTE2MTE1ODMuNjAuMC4w"
                alt="World Cat Advanced Search" title="Advanced Search Link"
                style="gap: 5px; display: flex; align-items: center;">Use Advanced Search<svg
                  xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <g clip-path="url(#clip0_2003_267)">
                    <path
                      d="M2.62268e-07 6C3.31826e-07 7.5913 0.632142 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 1.9271e-07 6 2.62268e-07C4.4087 3.31826e-07 2.88258 0.632142 1.75736 1.75736C0.632141 2.88258 1.9271e-07 4.4087 2.62268e-07 6ZM5.64844 8.83594C5.42813 9.05625 5.07188 9.05625 4.85391 8.83594C4.63594 8.61563 4.63359 8.25938 4.85391 8.04141L6.89297 6.00234L4.85391 3.96328C4.63359 3.74297 4.63359 3.38672 4.85391 3.16875C5.07422 2.95078 5.43047 2.94844 5.64844 3.16875L8.08594 5.60156C8.30625 5.82188 8.30625 6.17813 8.08594 6.39609L5.64844 8.83594Z"
                      fill="#01426A" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2003_267">
                      <rect width="12" height="12" fill="white" transform="translate(5.24537e-07 12) rotate(-90)" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </span>
          </div>

        </form>

      </div>
      <div class="hours-box" v-if="hourBlocks.length > 0">
        <span class="hours-title">library Hours</span>
        <span class="hours-range">{{ hourBlocks[0].office_hour_start_time }} - {{ hourBlocks[0].office_hour_end_time }}</span>
        <span class="hours-title"><span :class="'orb ' + (hourBlock.is_open ? 'open' : 'closed')"></span>{{
          hourBlock.is_open ? "open" :
            "closed" }} {{ hourBlock.is_open ? "now" : "until " + hourBlocks[0].office_hour_start_time }}</span>
        <a href="https://www.macalester.edu/calendar/building/?buildingId=8" title="Weekly Scheduled Hours"
          alt="Weekly Schedule link" class="base-cta dept-feature-url">Weekly Schedule</a>
      </div>
    </div>
  </div>
</template>

<script>
import tag from '@/js/util/props/tag'
import { useAttrs } from 'vue';


export default {
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: true,
      required: false
    },
    hourBlock: {
      type: Object,
      default: () => ({ is_open: false, active_blocks: [] })
    }
  },
  computed: {
    searchAction() {
      const baseUrl = 'https://macalester.on.worldcat.org/search';
      if (this.includeSpecialCollection) {
        return `${baseUrl}?scope=wz%3A1703`;
      }
      return baseUrl;
    },
    hourBlocks() {
      const existing = [];
      const blocks = (this.hourBlock && this.hourBlock.active_blocks) || [];
      return blocks.filter((block) => {
        if (existing.includes(block.section_title)) {
          return false;
        }
        existing.push(block.section_title);
        return true;
      });
    }
  },
  methods: {
    selectSearchBar(option) {
      this.selectedBar = option;
    },
    getQueryParams() {
      var urlParams = {};
      var match;
      var pl = /\+/g; // Regex for replacing addition symbol with a space
      var search = /([^&=]+)=?([^&]*)/g;
      var decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      };
      var query = window.location.search.substring(1);
      while ((match = search.exec(query)))
        urlParams[decode(match[1])] = decode(match[2]);
      return urlParams;
    },
    handleCheckboxChange() {
      // Update URL when checkbox changes
      this.updateSearchUrl();
    },
    formSubmit(bar) {
      event.preventDefault();
      this.$nextTick(() => {
        this.$refs.searchQuery.value = event.target.value;
      });

      // Add checkbox parameter to form submission
      if (this.includeSpecialCollection && this.$refs.specialCollectionInput) {
        this.$refs.specialCollectionInput.value = 'true';
      }
      console.log('References', this.$refs);
      this.$refs.WorldCatSearch.submit();
    }
  },
  data() {
    return {
      selectedBar: "",
      includeSpecialCollection: false,
      showTooltip: false,
    };
  },
  mounted() {
    var queryTerm = null;
    var qParams = this.getQueryParams();
    if (qParams.q && qParams.q.length && this.isSearch) {
      queryTerm = qParams.q;
      document.getElementById("LibrarySearchBar").value = queryTerm;
      this.selectedBar = "LibSearch";
    } else {
      this.selectedBar = "WorldCat";
    }



  }
};
</script>
<style scoped>
.library-search-form {
  display: flex;
  flex-direction: column;
}

.info-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 65%;

  @media screen and (max-width: 1024px) {
    max-width: 100%;
  }

  @media screen and (max-width: 500px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.box-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-right: 8px;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.the-header-search__input {
  flex: 1;
}

.info-box h3 {
  color: #01426A;
  font-family: Newslab;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
  /* 75% */
}

#checkboxDiv {
  display: flex;
  justify-content: space-between;
  justify-items: flex-start
}

#checkBox {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100% !important;
  width: auto;
  cursor: pointer;
  user-select: none;
}

.hidden-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.custom-checkbox {
  flex-shrink: 0;
  transition: all 0.2s ease;
}

#checkBox:hover .custom-checkbox rect {
  stroke: #023a5c;
}

.lib-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: help;
}

.info-icon {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.info-icon:hover {
  opacity: 0.7;
}

.tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  width: 200px;
  padding: 12px 14px;
  background: #FFFFFF;
  border-radius: 5px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.50);
  z-index: 1000;
  white-space: normal;
  word-wrap: break-word;
}

.tooltip p {
  color: #000;
  margin-bottom: 0 !important;
  font-family: "DIN Next LT Pro";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  /* 150% */
}

/* Responsive design */
@media (max-width: 640px) {
  .tooltip {
    width: 160px;
    font-size: 13px;
  }
}

/* Fade transition animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/js/components/LibrarySearchBar.vue